import React, {
  useState,
  createContext,
  useContext,
  useEffect,
  useRef,
  useMemo,
} from 'react'
import axios, { CancelToken as cancelToken } from 'axios'
import localConfig from '../../config/local-config'
import apiConfig from '../../config/api-config'
import useIsMounted from '../../hooks/useIsMounted'
import { LocalContext } from '../helpers/useLocalContext'

export const BlogContext = createContext()

export default function BlogProvider({
  children,
  attribute,
  limit = 3,
  pageType,
  article,
  width,
  height,
}) {
  const isMounted = useIsMounted()
  const { localContext } = useContext(LocalContext)
  const { isBot } = localContext
  const isServerSideRendered = Boolean(article) || isBot || false
  const [blogPosts, setBlogContent] = useState(null)
  const blogRequest = `${apiConfig.apiURL}/v1/blogs`
  const attribData = useMemo(() => {
    const params = {}
    const attr = attribute || {}
    Object.keys(attr).forEach(key => {
      let value
      const desc = Object.getOwnPropertyDescriptor(attr, key)

      if (desc) value = desc.value

      params[`tags[${key}]`] = value
    })

    return params
  }, [attribute])

  const blogCall = useRef(null)

  useEffect(() => {
    if (isServerSideRendered
      || blogCall.current) return () => {}

    blogCall.current = cancelToken.source();

    (async () => {
      try {
        const blogContents = await axios.get(blogRequest, {
          params: {
            domain: localConfig.hostname,
            limit,
            pageType,
            width,
            height,
            ...attribData,
          },
          headers: {
            apikey: apiConfig.apiKey,
          },
          cancelToken: blogCall.current.token,
        })

        const { data: responseData } = blogContents

        setBlogContent((isMounted() && (responseData.data && responseData.data.blogs)) || [])
      } catch (err) {
        if (axios.isCancel(err)) {
          console.warn('blog.provider', err)
        } else {
          console.error('blog.provider', err)
        }
      }
    })()

    return () => {
      if (blogCall.current && !isMounted()) {
        blogCall.current.cancel('unmount')
        blogCall.current = null
      }
    }
  }, [
    attribData,
    blogRequest,
    limit,
    pageType,
    width,
    height,
    isMounted,
    isServerSideRendered,
  ])

  return (
    <BlogContext.Provider value={blogPosts}>
      {children}
    </BlogContext.Provider>
  )
}
